import axios from 'axios';

const sendSms1 = (phone, message) => {
    return axios
    .post('https://us-central1-one-business-1ca39.cloudfunctions.net/widgets/sendSms', {
        message: message,
        phone: phone
    })
    // .then(response => {
    //         console.log(response)
    //     })
  }

  const sendWhatsApp1 = (phone, message) => {
    axios
    .post('https://us-central1-one-business-1ca39.cloudfunctions.net/widgets/sendWhatsApp', {
        message: message,
        phone: phone
    })
    .then(response => {
            console.log(response)
    })
  }
  
  export const sendSms = sendSms1
  export const sendWhatsApp = sendWhatsApp1


// WEBPACK FOOTER //
// ./src/services/twilio.js